import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";

const IndependentCard = ({ isMonthly }: { isMonthly: boolean }) => {
  const navigate = useNavigate();

  const Confirm = () => {
    navigate("/pricing/summary", {
      state: { isMonthly, ActivePackage: "independent" }
    });
  };
  return (
    <Container>
      <Header>
        <HeaderText>
          <Typography weight="semibold" size="xl" mb="0.8">
            Independent
          </Typography>
        </HeaderText>

        <Icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M11.4768 4.15044C11.7639 3.93444 12.0492 3.76822 12.3034 3.65088C12.3817 5.54155 13.3052 6.96288 14.1959 8.21977L14.4377 8.55933C15.4003 9.90866 16.2252 11.0651 16.315 12.5949C16.419 14.3567 15.9799 15.8455 15.1274 16.8829C14.2874 17.9069 12.9897 18.5558 11.2208 18.5558C9.38877 18.5558 8.01188 18.0855 7.0501 17.2971C6.09366 16.5122 5.48299 15.3584 5.27854 13.8553C5.07766 12.3771 5.43499 11.3264 5.82166 10.6527C5.8981 10.5202 5.97543 10.402 6.05099 10.2971L6.33099 10.8287C6.56674 11.2764 6.96644 11.6156 7.44652 11.7755C7.9266 11.9353 8.44989 11.9034 8.90699 11.6864C10.0679 11.1353 10.315 9.71933 9.94699 8.72644C9.68921 8.03133 9.55143 7.18244 9.84921 6.33177C10.1843 5.37888 10.8199 4.64733 11.4768 4.15044ZM5.80388 8.62155H5.8021L5.79854 8.62511L5.78966 8.63222C5.75104 8.66145 5.71368 8.69229 5.67766 8.72466C5.58425 8.80672 5.49468 8.89303 5.40921 8.98333C5.19588 9.20822 4.9221 9.54244 4.66521 9.98955C4.14788 10.8918 3.71321 12.2367 3.95766 14.0349C4.19854 15.81 4.94432 17.2935 6.20477 18.3282C7.46166 19.3593 9.16299 19.8891 11.2208 19.8891C13.3425 19.8891 15.0368 19.0935 16.1577 17.7291C17.2688 16.3771 17.7648 14.5327 17.6465 12.5167C17.5328 10.5824 16.4794 9.11488 15.5488 7.81888L15.283 7.44822C14.2679 6.01533 13.467 4.69533 13.6617 2.84822C13.6715 2.75525 13.6617 2.66126 13.6328 2.57233C13.604 2.48341 13.5568 2.40154 13.4943 2.33205C13.4317 2.26256 13.3553 2.207 13.2699 2.16897C13.1845 2.13095 13.092 2.11131 12.9985 2.11133C12.659 2.11133 12.2697 2.21622 11.8945 2.37444C11.4601 2.56059 11.0503 2.79942 10.6741 3.08555C9.85188 3.70599 9.02965 4.64111 8.59143 5.89088C8.1541 7.13711 8.37632 8.32466 8.69632 9.18955C8.90699 9.75755 8.67854 10.3184 8.33454 10.482C8.18818 10.5512 8.02071 10.5612 7.86715 10.5099C7.71358 10.4585 7.58581 10.3498 7.51054 10.2064L6.7941 8.84555C6.74926 8.76018 6.68643 8.68555 6.60995 8.62681C6.53347 8.56807 6.44516 8.52663 6.3511 8.50533C6.25705 8.48404 6.1595 8.4834 6.06518 8.50346C5.97085 8.52353 5.88112 8.56382 5.80388 8.62155Z"
              fill="#F5F5F5"
            />
          </svg>
        </Icon>
      </Header>
      <Typography color={Colors.grey300} mb="3.4">
        Perfect for independent artists looking to get started with
        distribution. Affordable rates and essential tools to launch your music
        journey.
      </Typography>
      <PriceDiv>
        <Typography size="4.8rem" weight="semibold" mr="0.8">
          $2
        </Typography>
        <Typography lh="4" color={Colors.grey500}>
          per month
        </Typography>
      </PriceDiv>

      <PrimaryButton
        text="Release Your First Track"
        inset
        variant="white"
        onClick={Confirm}
      />
    </Container>
  );
};

export default IndependentCard;

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 0.8rem;
  border: 1px solid #4e4c44;
  padding: 1.6rem;
  background: linear-gradient(
    108deg,
    rgba(30, 30, 30, 0.8) 0.85%,
    rgba(19, 19, 19, 0.8) 100%
  );
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.4rem;
  @media only screen and (max-width: 769px) {
    margin-bottom: 2.4rem;
  }
`;

const HeaderText = styled.div``;

const Icon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  border-top: 1px solid #a9a28c;
  background: #0d0d0d;
  box-shadow: 0px 4px 4px 0px rgba(50, 50, 50, 0.5) inset;
  padding: 0.5rem;
`;

const PriceDiv = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: 2.4rem;
`;

const MobileSection = styled.div`
  display: none;
  @media only screen and (max-width: 769px) {
    display: block;
    margin-bottom: 3.2rem;
  }
`;

const CheckItem = styled.div`
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
`;

const TickIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
`;
